import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { IUser } from "Auth/types";

const { suggestEdit, errors } = copy;

export const fields: IFormFields = [
  {
    type: IFieldType.email,
    name: "email",
    label: suggestEdit.fields.email,
    validation: {
      required: errors.required,
    },
  },
  {
    type: IFieldType.textarea,
    name: "suggestion",
    label: suggestEdit.fields.suggestion,
    style: {
      rows: 10,
    },
    validation: {
      required: errors.required,
    },
  },
];

export const getDefaultValues = (currentUser?: IUser | null) => ({
  email: currentUser?.attributes?.email || "",
});
